import { useRouter } from 'next/router';
import { mapPlaylistItems } from "@/lib/utils";
import ShopPanel from '../panels/ShopPanel';
import DailyPanel from '../panels/DailyPanel';
import EndlessChallengeSummary from './EndlessChallengeSummary';
import PlaylistPanel from '@/components/panels/PlaylistPanel';
import TrendingPanel from '../panels/TrendingPanel';
import StaffPanel from '@/components/panels/StaffPanel';
import PanelButton, {TYPE_BACK} from '../panels/PanelButton';
import PanelGrid from "@/components/panels/PanelGrid";
import InfoPanel from "../panels/InfoPanel";
import Disclaimer from "../panels/Disclaimer";
import LiveModePanel from '@/components/panels/LiveModePanel';

const Summary = ({pursuit = {}, onShare, onChallenge, onQuestionFeedback, onPlaylistFeedback}) => {
	const router = useRouter()

	return (<>
		<PanelGrid className={`min-w-[360px] xl:mb-0`}>
			<div className="grid gap-2 mb-2 xl:order-2 xl:col-span-4">
				<EndlessChallengeSummary pursuit={pursuit} onShare={onShare} onChallenge={onChallenge} onQuestionFeedback={onQuestionFeedback} onPlaylistFeedback={onPlaylistFeedback} />
				<div className={'hidden xl:grid xl:gap-2'}>
					<DailyPanel />
					<PlaylistPanel />
				</div>
			</div>
			<div className="grid gap-2 mb-2 xl:order-1 xl:col-span-3">
				<StaffPanel className="order-1 xl:order-0" />
				<LiveModePanel className="order-0 xl:order-1" />
				<div className={'xl:hidden grid gap-2 order-2'}>
					<DailyPanel />
					<PlaylistPanel />
				</div>
			</div>
			<div className="grid gap-2 mb-2 xl:order-3 xl:col-span-3">
				<TrendingPanel />
				<ShopPanel className={'inline-flex'}/>
				<InfoPanel className={'inline-flex'}/>
			</div>
		</PanelGrid>
		<div className={`mb-4 md:mb-6 xl:mb-auto xl:mt-4`}>
			<PanelButton type={TYPE_BACK} onClick={() => router.push('/')}/>
		</div>
		<Disclaimer/>
	</>);
};

export default Summary;
